import { TThunkAction } from '../../types/redux/thunk';
import { TResultSuggestion } from '../../types/suggest';
import { setFieldsState } from '../fieldsState';
import { getFlatStats, setFlatStats } from '../flatStats';

export function changeAddress(address: TResultSuggestion): TThunkAction<Promise<void>> {
  return async dispatch => {
    dispatch(setFieldsState({ address }));

    const flatStatsResult = await dispatch(getFlatStats());

    if (!flatStatsResult.success) {
      dispatch(setFieldsState({ address: null }));

      return;
    }

    dispatch(setFlatStats());
  };
}
